import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { A11yProvider } from "@/context/A11yContext";
import { AccessibilityToolbar } from "@/components/site/AccessibilityToolbar";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  return (
    <A11yProvider>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <div className="App">
          <a href="#main" className="skip-link">Skip to main content</a>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
          <AccessibilityToolbar />
          <Toaster position="top-center" richColors />
        </div>
      </ReactLenis>
    </A11yProvider>
  );
}

export default App;
